<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ToursStoreMixin extends Vue {
        get productStore() {
            return toursStore
        }

        get productRuntimeStore() {
            return toursRuntimeStore
        }

        get productType() {
            return 'tours'
        }
    }

    export default ToursStoreMixin
</script>
